import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const ESGInfo: FC = () => {
  const params = useParams<{ symbol: string }>();

  useEffect(() => {
    const symbol = params.symbol;

    window.location.href =
      `https://www.settrade.com/th/equities/quote/${symbol}/esg-information`;
  }, [params.symbol]);

  return <div></div>;
};

export default ESGInfo;
